import axios from "axios";
import API_CONFIG from "../config/api";

const REFRESH_URL = "/Painel/API/Auth/refresh.php";

export const api = axios.create({
    baseURL: API_CONFIG.baseURL,
    withCredentials: true
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
    failedQueue.forEach(({ resolve, reject, config }) => {
        if (error) {
            reject(error);
        } else {
            resolve(api(config));
        }
    });
    failedQueue = [];
};

const redirectToLogin = () => {
    if (typeof window === "undefined") return;

    const path = window.location.pathname;
    if (path !== "/login" && path !== "/register") {
        window.location.href = "/login";
    }
};

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (!error.response || !originalRequest) {
            return Promise.reject(error);
        }

        const url = originalRequest.url || "";
        const isRefreshCall = url.includes("Auth/refresh.php");
        const isLoginCall = url.includes("API/Login");

        const shouldTryRefresh =
            error.response.status === 401 &&
            !isRefreshCall &&
            !isLoginCall &&
            !originalRequest._retry;

        if (!shouldTryRefresh) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject, config: originalRequest });
            });
        }

        isRefreshing = true;

        try {
            await api.post(REFRESH_URL);
            processQueue(null);
            return api(originalRequest);
        } catch (refreshError) {
            processQueue(refreshError);
            redirectToLogin();
            return Promise.reject(refreshError);
        } finally {
            isRefreshing = false;
        }
    }
);

const useApi = () => api;

export default useApi;
